import { __decorate } from 'tslib';
import { SimpleChange } from '@angular/core';
import { Debounce } from '@js-dot/core';
const BLANK = {};
class DotInheritBase {
  _zone = BLANK;
  _alias = BLANK;
  set zone(option) {
    this._zone = option || BLANK;
    this._dotOnInherit();
  }
  get zone() {
    return this._zone;
  }
  set alias(alias) {
    this._alias = alias || BLANK;
    this._dotOnInherit();
  }
  get alias() {
    return this._alias;
  }
  _dotOnInherit() {
    this.dotOnInherit();
  }
  inherit(propertyName) {
    return this[propertyName] || this.alias[propertyName] || this.zone[propertyName];
  }
  change(property, value) {
    if (value && typeof value === 'object') {
      if (value instanceof SimpleChange) {
        value = value.currentValue;
      } else {
        value = value[property]?.currentValue;
      }
    }
    if (this[property] !== value) {
      this[property] = value;
      this._dotOnInherit();
    }
  }
}
__decorate([Debounce(24)], DotInheritBase.prototype, "_dotOnInherit", null);

/**
 * Generated bundle index. Do not edit.
 */

export { DotInheritBase };
